/** @format */

const template = `
<ui-select
  multiple="multiple"
  dupes="false"
  reset-search-input="true"
  ng-model="ctrl.selectedResults"
  on-select="ctrl.selectEmployee($item)"
  on-remove="ctrl.removeEmployee($item)"
  theme="bootstrap"
  append-to-body="false">
  <ui-select-match placeholder="{{ 'EMPLOYEE_SEARCH_PLACEHOLDER' | translate}}">
    {{ ctrl.getEmployeeFullName($item) }}
    <small ng-if="$item.primaryEmail"> &lt;{{$item.primaryEmail}}&gt; </small>
  </ui-select-match>
  <ui-select-choices
    position="down"
    ui-disable-choice="ctrl.disableChoice(employee)"
    repeat="employee in ctrl.results"
    refresh="ctrl.doSearch($select.search)"
    refresh-delay="399">
    <span>
      <span>{{employee.lastName}}</span>
      <span>{{employee.firstNames}}</span>
      <small ng-if="employee.primaryEmail"> &lt;<span>{{employee.primaryEmail}}</span>&gt; </small>
      <small ng-if="employee.secondaryEmail"> &lt;<span>{{employee.secondaryEmail}}</span>&gt; </small>
    </span>
  </ui-select-choices>
</ui-select>
<sis-icon icon="search" class="search-with-svg-icon"></sis-icon>
`;
export default template;
